import { render } from "./flocker.vue?vue&type=template&id=74638dee"
import script from "./flocker.vue?vue&type=script&lang=js"
export * from "./flocker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__